"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import Group from "../../layout/Group/Group.js";
import TextLink from "../../navigation/TextLink/TextLink.js";
import Modal from "../../overlay/Modal/Modal.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { forwardRef, useState } from "react";
import Button from "../Button/Button.js";
import '../../../assets/ModalButton.css';const root = "_root_yfehc_2";
const button = "_button_yfehc_19";
const link = "_link_yfehc_27";
const ModalButtonStyles = {
  root,
  button,
  link
};
const _ModalButton = forwardRef((props, ref) => {
  const {
    modalContent,
    title,
    opened,
    onClose,
    withCloseButton,
    closeButtonLabel,
    target,
    color = "dark",
    buttonText,
    variant = "link",
    background,
    icon,
    className,
    ...rest
  } = props;
  const [localOpened, setLocalOpened] = useState(Boolean(opened));
  const handleOnClose = () => {
    setLocalOpened(false);
    if (onClose) {
      onClose();
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Modal,
      {
        opened: localOpened,
        onClose: handleOnClose,
        title,
        withCloseButton,
        closeButtonLabel,
        target,
        background,
        className: ModalButtonStyles.root,
        children: modalContent
      }
    ),
    /* @__PURE__ */ jsx(
      Group,
      {
        ...rest,
        className: `${ModalButtonStyles.button} ${className}`,
        onClick: () => setLocalOpened(true),
        align: "center",
        ref,
        children: variant === "link" ? /* @__PURE__ */ jsx(
          TextLink,
          {
            text: buttonText,
            href: "/",
            variant: "inline",
            onClick: (e) => e.preventDefault(),
            color,
            className: ModalButtonStyles.link
          }
        ) : /* @__PURE__ */ jsx(
          Button,
          {
            text: buttonText,
            onClick: (e) => e.preventDefault(),
            icon,
            variant
          }
        )
      }
    )
  ] });
});
_ModalButton.displayName = "ModalButton";
const ModalButton = sharedHandler(_ModalButton);
ModalButton.displayName = _ModalButton.displayName;
export {
  ModalButtonStyles as M,
  ModalButton as default
};
